var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 17.25C17 17.6642 16.6642 18 16.25 18L3.75 18C3.33579 18 3 17.6642 3 17.25C3 16.8358 3.33579 16.5 3.75 16.5L16.25 16.5C16.6642 16.5 17 16.8358 17 17.25ZM10 14.5C9.5858 14.5 9.25001 14.1642 9.25001 13.75L9.25001 4.56066L6.53033 7.28033C6.23744 7.57322 5.76256 7.57322 5.46967 7.28033C5.17678 6.98744 5.17678 6.51256 5.46967 6.21967L9.46968 2.21967C9.61033 2.07902 9.8011 2 10 2C10.1989 2 10.3897 2.07902 10.5303 2.21967L14.5303 6.21967C14.8232 6.51256 14.8232 6.98744 14.5303 7.28033C14.2374 7.57322 13.7626 7.57322 13.4697 7.28033L10.75 4.56066L10.75 13.75C10.75 14.1642 10.4142 14.5 10 14.5Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "b4d346f5e246ce2ecb07ba6e771a96f9.svg";
export { ForwardRef as ReactComponent };